var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8926 9.61452C31.4357 9.53836 30.9597 9.51935 30.4647 9.51935H11.4259C10.8928 9.51935 10.3788 9.55742 9.88379 9.63357C10.1503 9.10049 10.5311 8.60554 10.988 8.14861L17.1756 1.94195C19.7839 -0.647318 24.0106 -0.647318 26.6189 1.94195L29.9506 5.31174C31.1691 6.51118 31.8164 8.0343 31.8926 9.61452Z",
    fill: "#40D7A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.90759 27.3398V19.0389C1.90759 13.8604 5.02996 10.243 9.88484 9.63376C10.3798 9.5576 10.8939 9.51953 11.427 9.51953H30.4657C30.9607 9.51953 31.4367 9.53855 31.8936 9.6147C36.8056 10.1859 39.9851 13.8223 39.9851 19.0389V28.5583C39.9851 33.813 35.7204 38.0777 30.4657 38.0777H12.6264H11.427C6.17228 38.0777 1.90759 33.813 1.90759 28.5583V27.3398Z",
    fill: "#40D7A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9851 19.9907H34.2735C32.1792 19.9907 30.4657 21.7042 30.4657 23.7985C30.4657 25.8927 32.1792 27.6062 34.2735 27.6062H39.9851",
    fill: "#40D7A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.442651 37.4679L1.88959 36.0209C1.12804 34.8786 0.69015 33.5079 0.69015 32.0419C0.69015 28.0247 3.94578 24.769 7.96296 24.769C11.9801 24.769 15.2358 28.0247 15.2358 32.0419C15.2358 36.059 11.9801 39.3147 7.96296 39.3147C6.49697 39.3147 5.12617 38.8768 3.98385 38.1152L2.53691 39.5622C2.25133 39.8478 1.87055 40.0001 1.48977 40.0001C1.109 40.0001 0.728233 39.8478 0.442651 39.5622C-0.14755 38.972 -0.14755 38.039 0.442651 37.4679Z",
    fill: "#40D7A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStatus);
export default __webpack_public_path__ + "static/media/UserStatus.f133b52b3061d27f26ecb65702a3403c.svg";
export { ForwardRef as ReactComponent };